// Generated by purs version 0.15.15
import * as Color from "../Color/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Effect from "../Effect/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Record from "../Record/index.js";
import * as Visonum_Cross_Default from "../Visonum.Cross.Default/index.js";
import * as Visonum_Cross_Foreign from "../Visonum.Cross.Foreign/index.js";
import * as Visonum_Cross_Types_Brand_Visonum from "../Visonum.Cross.Types.Brand.Visonum/index.js";
var union = /* #__PURE__ */ Record.union();
var defaultRecord = /* #__PURE__ */ Visonum_Cross_Default.defaultRecord();
var defaultRLCons = /* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(Visonum_Cross_Default.defaultRLNilRow);
var defaultRLCons1 = /* #__PURE__ */ defaultRLCons(Visonum_Cross_Default.defaultMaybe)();
var defaultRLCons2 = /* #__PURE__ */ defaultRLCons(Visonum_Cross_Default.defaultBoolean)();
var defaultRecord1 = /* #__PURE__ */ defaultRecord(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ defaultRLCons2({
    reflectSymbol: function () {
        return "showTable";
    }
})())(Visonum_Cross_Default.defaultBoolean)()({
    reflectSymbol: function () {
        return "disableTabs";
    }
})());
var showIsSymbol = {
    reflectSymbol: function () {
        return "show";
    }
};
var defaultRLCons3 = /* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ defaultRLCons1({
    reflectSymbol: function () {
        return "targetElem";
    }
})())(/* #__PURE__ */ defaultRecord(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ defaultRLCons1({
    reflectSymbol: function () {
        return "width";
    }
})())(Visonum_Cross_Default.defaultMaybe)()({
    reflectSymbol: function () {
        return "height";
    }
})()))()({
    reflectSymbol: function () {
        return "size";
    }
})())(Visonum_Cross_Default.defaultBoolean)()({
    reflectSymbol: function () {
        return "showWidgetStartButton";
    }
})())(Visonum_Cross_Default.defaultBoolean)()({
    reflectSymbol: function () {
        return "showRapidPing";
    }
})())(Visonum_Cross_Default.defaultBoolean)()({
    reflectSymbol: function () {
        return "showMenu";
    }
})())(Visonum_Cross_Default.defaultBoolean)()({
    reflectSymbol: function () {
        return "showLogo";
    }
})())(Visonum_Cross_Default.defaultBoolean)()({
    reflectSymbol: function () {
        return "showHeader";
    }
})())(Visonum_Cross_Default.defaultBoolean)()({
    reflectSymbol: function () {
        return "showBackground";
    }
})())(defaultRecord1)()({
    reflectSymbol: function () {
        return "resultScreen";
    }
})())(Visonum_Cross_Default.defaultMaybe)()({
    reflectSymbol: function () {
        return "onSpeedtestFinish";
    }
})())(Visonum_Cross_Default.defaultMaybe)()({
    reflectSymbol: function () {
        return "onFinish";
    }
})())(Visonum_Cross_Default.defaultMaybe)()({
    reflectSymbol: function () {
        return "maxBookedSpeed";
    }
})())(Visonum_Cross_Default.defaultMaybe)()({
    reflectSymbol: function () {
        return "logoURL";
    }
})())(/* #__PURE__ */ defaultRecord(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ defaultRLCons(Visonum_Cross_Default.defaultString)()({
    reflectSymbol: function () {
        return "text";
    }
})())(Visonum_Cross_Default.defaultBoolean)()(showIsSymbol)()))()({
    reflectSymbol: function () {
        return "headline";
    }
})();
var fromFoldable = /* #__PURE__ */ Foreign_Object.fromFoldable(Data_Foldable.foldableArray);
var toForeign = /* #__PURE__ */ Visonum_Cross_Foreign.toForeign(Visonum_Cross_Foreign.toForeignSpeed);
var toForeign1 = /* #__PURE__ */ Visonum_Cross_Foreign.toForeign(Visonum_Cross_Foreign.toForeignNumber);
var toForeign2 = /* #__PURE__ */ Visonum_Cross_Foreign.toForeign(/* #__PURE__ */ Visonum_Cross_Foreign.toForeignObject(Visonum_Cross_Foreign.toForeignForeign));
var apply = /* #__PURE__ */ Control_Apply.apply(Effect.applyEffect);
var map = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var fromForeign = /* #__PURE__ */ Visonum_Cross_Foreign.fromForeign(Visonum_Cross_Foreign.fromForeignNumber);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var fromForeign1 = /* #__PURE__ */ Visonum_Cross_Foreign.fromForeign(Visonum_Cross_Foreign.fromForeignBoolean);
var fromForeign2 = /* #__PURE__ */ Visonum_Cross_Foreign.fromForeign(Visonum_Cross_Foreign.fromForeignString);
var defaultRecord2 = /* #__PURE__ */ defaultRecord(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(/* #__PURE__ */ defaultRLCons2({
    reflectSymbol: function () {
        return "showStreams";
    }
})())(Visonum_Cross_Default.defaultBoolean)()(showIsSymbol)());
var fromForeign3 = /* #__PURE__ */ Visonum_Cross_Foreign.fromForeign(Visonum_Cross_Foreign.fromForeignColor);
var fromForeignEff = /* #__PURE__ */ Visonum_Cross_Foreign.fromForeignEff(/* #__PURE__ */ Visonum_Cross_Foreign.fromForeignEff1(Visonum_Cross_Foreign.fromForeignBoolean));
var fromForeign4 = /* #__PURE__ */ Visonum_Cross_Foreign.fromForeign(Visonum_Cross_Foreign.fromForeignHTMLElement);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var fromForeign5 = /* #__PURE__ */ Visonum_Cross_Foreign.fromForeign(Visonum_Cross_Foreign.fromForeignSpeed);
var def = /* #__PURE__ */ Visonum_Cross_Default.def(defaultRecord2);
var def1 = /* #__PURE__ */ Visonum_Cross_Default.def(defaultRecord1);
var toForeign3 = /* #__PURE__ */ Visonum_Cross_Foreign.toForeign(Visonum_Cross_Foreign.toForeignString);
var EmbedOpts_ = function (x) {
    return x;
};
var velocityEmbedOpts = /* #__PURE__ */ union({
    colorTheme: Visonum_Cross_Types_Brand_Visonum.velocityUIColors,
    chart: {
        show: true,
        showStreams: true
    }
})(/* #__PURE__ */ Visonum_Cross_Default.def(/* #__PURE__ */ defaultRecord(defaultRLCons3)));
var speedtestResultToForeign = function (args) {
    var obj = fromFoldable([ new Data_Tuple.Tuple("upload", toForeign(args.upload)), new Data_Tuple.Tuple("download", toForeign(args.download)), new Data_Tuple.Tuple("ping", toForeign1(args.ping)) ]);
    return toForeign2(obj);
};
var sizeFromForeignEff = function (jsval) {
    return apply(map(function (v) {
        return function (v1) {
            return {
                width: v,
                height: v1
            };
        };
    })(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "width",
        parse: function ($227) {
            return pure(Data_Maybe.Just.create(fromForeign($227)));
        },
        "default": Data_Maybe.Nothing.value,
        details: "Option must be a number.",
        example: "100"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "height",
        parse: function ($228) {
            return pure(Data_Maybe.Just.create(fromForeign($228)));
        },
        "default": Data_Maybe.Nothing.value,
        details: "Option must be a number.",
        example: "100"
    }));
};
var resultScreenFromForeignEff = function (jsval) {
    return apply(map(function (v) {
        return function (v1) {
            return {
                showTable: v,
                disableTabs: v1
            };
        };
    })(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "showTable",
        parse: function ($229) {
            return pure(fromForeign1($229));
        },
        "default": false,
        details: "Option must be a boolean.",
        example: "true"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "disableTabs",
        parse: function ($230) {
            return pure(fromForeign1($230));
        },
        "default": false,
        details: "Option must be a boolean.",
        example: "true"
    }));
};
var headlineFromForeignEff = function (jsval) {
    return apply(map(function (v) {
        return function (v1) {
            return {
                show: v,
                text: v1
            };
        };
    })(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "show",
        parse: function ($231) {
            return pure(fromForeign1($231));
        },
        "default": false,
        details: "Option must be a boolean.",
        example: "true"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "text",
        parse: function ($232) {
            return pure(fromForeign2($232));
        },
        "default": "",
        details: "Option must be a string.",
        example: "Headline"
    }));
};
var defaultEmbedOpts = /* #__PURE__ */ union({
    colorTheme: Visonum_Cross_Types_Brand_Visonum.visonumColors
})(/* #__PURE__ */ Visonum_Cross_Default.def(/* #__PURE__ */ defaultRecord(/* #__PURE__ */ Visonum_Cross_Default.defaultRLCons(defaultRLCons3)(defaultRecord2)()({
    reflectSymbol: function () {
        return "chart";
    }
})())));
var colorThemeFromForeignEff = function (jsval) {
    return apply(apply(apply(apply(apply(apply(apply(apply(map(function (v) {
        return function (v1) {
            return function (v2) {
                return function (v3) {
                    return function (v4) {
                        return function (v5) {
                            return function (v6) {
                                return function (v7) {
                                    return function (v8) {
                                        return {
                                            primary500: v,
                                            secondary400: v1,
                                            tertiary400: v2,
                                            gray0: v3,
                                            gray500: v4,
                                            gray600: v5,
                                            gray700: v6,
                                            gray800: v7,
                                            gray900: v8
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "primary500",
        parse: function ($233) {
            return pure(fromForeign3($233));
        },
        "default": Color.white,
        details: "Option must be a Hex color.",
        example: "#cccccc"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "secondary400",
        parse: function ($234) {
            return pure(fromForeign3($234));
        },
        "default": Color.white,
        details: "Option must be a Hex color.",
        example: "#cccccc"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "tertiary400",
        parse: function ($235) {
            return pure(fromForeign3($235));
        },
        "default": Color.white,
        details: "Option must be a Hex color.",
        example: "#cccccc"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "gray0",
        parse: function ($236) {
            return pure(fromForeign3($236));
        },
        "default": Color.white,
        details: "Option must be a Hex color.",
        example: "#cccccc"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "gray500",
        parse: function ($237) {
            return pure(fromForeign3($237));
        },
        "default": Color.white,
        details: "Option must be a Hex color.",
        example: "#cccccc"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "gray600",
        parse: function ($238) {
            return pure(fromForeign3($238));
        },
        "default": Color.white,
        details: "Option must be a Hex color.",
        example: "#cccccc"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "gray700",
        parse: function ($239) {
            return pure(fromForeign3($239));
        },
        "default": Color.white,
        details: "Option must be a Hex color.",
        example: "#cccccc"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "gray800",
        parse: function ($240) {
            return pure(fromForeign3($240));
        },
        "default": Color.white,
        details: "Option must be a Hex color.",
        example: "#cccccc"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "gray900",
        parse: function ($241) {
            return pure(fromForeign3($241));
        },
        "default": Color.white,
        details: "Option must be a Hex color.",
        example: "#cccccc"
    }));
};
var chartOptsFromForeignEff = function (jsval) {
    return apply(map(function (v) {
        return function (v1) {
            return {
                show: v,
                showStreams: v1
            };
        };
    })(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "show",
        parse: fromForeignEff,
        "default": false,
        details: "Option must be a boolean.",
        example: "true"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "showStreams",
        parse: function ($242) {
            return pure(fromForeign1($242));
        },
        "default": false,
        details: "Option must be a boolean.",
        example: "true"
    }));
};
var embedOptsFromForeignEff = function (jsval) {
    return apply(apply(apply(apply(apply(apply(apply(apply(apply(apply(apply(apply(apply(apply(apply(map(function (v) {
        return function (v1) {
            return function (v2) {
                return function (v3) {
                    return function (v4) {
                        return function (v5) {
                            return function (v6) {
                                return function (v7) {
                                    return function (v8) {
                                        return function (v9) {
                                            return function (v10) {
                                                return function (v11) {
                                                    return function (v12) {
                                                        return function (v13) {
                                                            return function (v14) {
                                                                return function (v15) {
                                                                    return {
                                                                        targetElem: v,
                                                                        maxBookedSpeed: v1,
                                                                        onSpeedtestFinish: v2,
                                                                        showHeader: v3,
                                                                        headline: v4,
                                                                        showLogo: v5,
                                                                        logoURL: v6,
                                                                        showWidgetStartButton: v7,
                                                                        showMenu: v8,
                                                                        showBackground: v9,
                                                                        showRapidPing: v10,
                                                                        chart: v11,
                                                                        colorTheme: v12,
                                                                        size: v13,
                                                                        onFinish: v14,
                                                                        resultScreen: v15
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "targetElem",
        parse: (function () {
            var $243 = map1(wrap);
            return function ($244) {
                return pure(Data_Maybe.Just.create($243(fromForeign4($244))));
            };
        })(),
        "default": Data_Maybe.Nothing.value,
        details: "Option must be an HTMLElement.",
        example: "document.getElementById('app')"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "maxBookedSpeed",
        parse: function ($245) {
            return pure(Data_Maybe.Just.create(fromForeign5($245)));
        },
        "default": Data_Maybe.Nothing.value,
        details: "Option must be a number representing bps.",
        example: "50_000_000_000"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "onSpeedtestFinish",
        parse: (function () {
            var $246 = map1(wrap);
            var $247 = Visonum_Cross_Foreign.functionFromForeign_(function ($249) {
                return pure(speedtestResultToForeign($249));
            });
            return function ($248) {
                return pure(Data_Maybe.Just.create($246($247($248))));
            };
        })(),
        "default": Data_Maybe.Nothing.value,
        details: "Option must be a callback function.",
        example: "({upload, download, ping}) => { console.log(upload) }"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "showHeader",
        parse: function ($250) {
            return pure(fromForeign1($250));
        },
        "default": false,
        details: "Option must be a boolean.",
        example: "true"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "headline",
        parse: (function () {
            var $251 = map(Data_Maybe.Just.create);
            return function ($252) {
                return $251(headlineFromForeignEff($252));
            };
        })(),
        "default": {
            show: false,
            text: ""
        },
        details: "Option must be an object.",
        example: "{ show: true, text: 'Headline' }"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "showLogo",
        parse: function ($253) {
            return pure(fromForeign1($253));
        },
        "default": false,
        details: "Option must be a boolean.",
        example: "true"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "logoURL",
        parse: function ($254) {
            return pure(Data_Maybe.Just.create(fromForeign2($254)));
        },
        "default": Data_Maybe.Nothing.value,
        details: "Option must be an URL pointing to a png/jpg/svg image.",
        example: ""
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "showWidgetStartButton",
        parse: function ($255) {
            return pure(fromForeign1($255));
        },
        "default": false,
        details: "Option must be a boolean.",
        example: "true"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "showMenu",
        parse: function ($256) {
            return pure(fromForeign1($256));
        },
        "default": false,
        details: "Option must be a boolean.",
        example: "true"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "showBackground",
        parse: function ($257) {
            return pure(fromForeign1($257));
        },
        "default": false,
        details: "Option must be a boolean.",
        example: "true"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "showRapidPing",
        parse: function ($258) {
            return pure(fromForeign1($258));
        },
        "default": false,
        details: "Option must be a boolean.",
        example: "true"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "chart",
        parse: (function () {
            var $259 = map(Data_Maybe.Just.create);
            return function ($260) {
                return $259(chartOptsFromForeignEff($260));
            };
        })(),
        "default": def,
        details: "Option must be an object",
        example: "{}"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "colorTheme",
        parse: (function () {
            var $261 = map(Data_Maybe.Just.create);
            return function ($262) {
                return $261(colorThemeFromForeignEff($262));
            };
        })(),
        "default": Visonum_Cross_Types_Brand_Visonum.visonumColors,
        details: "Option must be an object.",
        example: "{}"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "size",
        parse: (function () {
            var $263 = map(Data_Maybe.Just.create);
            return function ($264) {
                return $263(sizeFromForeignEff($264));
            };
        })(),
        "default": {
            width: Data_Maybe.Nothing.value,
            height: Data_Maybe.Nothing.value
        },
        details: "Option must be an object.",
        example: "{ width: 100, height: 100 }"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "onFinish",
        parse: (function () {
            var $265 = map1(wrap);
            var $266 = Visonum_Cross_Foreign.functionFromForeign_(function ($268) {
                return pure(embedApiToForeign($268));
            });
            return function ($267) {
                return pure(Data_Maybe.Just.create($265($266($267))));
            };
        })(),
        "default": Data_Maybe.Nothing.value,
        details: "Option must be a callback function.",
        example: "({ setOptions }) => { console.log(setOptions) }"
    })))(Visonum_Cross_Foreign.parseOption(jsval)({
        key: "resultScreen",
        parse: (function () {
            var $269 = map(Data_Maybe.Just.create);
            return function ($270) {
                return $269(resultScreenFromForeignEff($270));
            };
        })(),
        "default": def1,
        details: "Option must be an object.",
        example: "{}"
    }));
};
var embedApiToForeign = function (api) {
    var setOptions = Visonum_Cross_Foreign.functionToForeign_((function () {
        var $271 = map(function ($273) {
            return Data_Maybe.Just.create(EmbedOpts_($273));
        });
        return function ($272) {
            return $271(embedOptsFromForeignEff($272));
        };
    })())(api.setOptions);
    return toForeign2(fromFoldable([ new Data_Tuple.Tuple("setOptions", setOptions) ]));
};
var crossApiToForeign = function (args) {
    var embedSpeedtest = Visonum_Cross_Foreign.functionToForeign_((function () {
        var $274 = map(Data_Maybe.Just.create);
        return function ($275) {
            return $274(embedOptsFromForeignEff($275));
        };
    })())(args.embedSpeedtest);
    var obj = fromFoldable([ new Data_Tuple.Tuple("version", toForeign3(args.version)), new Data_Tuple.Tuple("embedSpeedtest", embedSpeedtest) ]);
    return toForeign2(obj);
};
export {
    EmbedOpts_,
    crossApiToForeign,
    defaultEmbedOpts,
    velocityEmbedOpts
};
//# sourceMappingURL=index.js.map
